import React, { useState } from 'react'

import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { ExcludeNonAdmin } from 'utils/helpers'
import AddressAccessAdminPage from '../AddressAccessAdminPage'

function EmergencyAdminPage({ userCompanyUuid, partnerCurrent, user }) {
  return (
    <ExcludeNonAdmin authUser={user}>
      <AddressAccessAdminPage />
    </ExcludeNonAdmin>
  )
}

const mapStateToProps = (state) => {
  const { auth, partners } = state

  return {
    userCompanyUuid: auth.user.company.uuid,
    dataCurrent: partners.current,
    user: auth.user,
  }
}

export default connect(mapStateToProps)(withRouter(EmergencyAdminPage))
